import type { TrainingGoalPeriod } from '../types'

/** Sample data. Real goal periods and workout counts are persisted by the backend (Marco 3). */
const currentYear = new Date().getFullYear()

export const trainingGoalPeriods: TrainingGoalPeriod[] = [
  { id: `period-${currentYear}-01-01`, weeklyTarget: 3, effectiveFrom: new Date(currentYear, 0, 1) },
]

/** Workouts completed so far this year (sample). */
export const trainingsCompletedThisYear = 112

export const TRAINING_GOAL_MIN = 1
export const TRAINING_GOAL_MAX = 14
